const billwerkStaticData = {
    publicApiKey: "62667259724c720eacaa8be4",
  };
  
  export { billwerkStaticData };
  
